import Notifications from 'react-notification-system-redux';
import { all, call, put, takeLatest } from 'redux-saga/effects';

import { closeModal } from '../../containers/Full/actions';
import { getRequestErrorMessage } from '../../utilities/SagasHelper';
import * as api from '../../utilities/ServiceManager';
import { setAllStudyPrograms } from '../Quals/actions';
import {
  addQual,
  addRate,
  removeSP,
  setQuals,
  setRates,
  setSelectedSP,
  updateSP as updateSPAction,
  waiting,
} from './actions';
import {
  CREATE_RATE,
  DELETE_SP,
  LOAD_ALL_RATES,
  LOAD_QUALS,
  LOAD_RATES,
  UPDATE_SP,
} from './actionTypesSagas';
/**
 * LOAD RATES
 */
function* loadRatesSaga() {
  yield takeLatest(LOAD_RATES, callLoadRates);
}

function* callLoadRates(action) {
  try {
    const rates = yield call(api.getRates, action.page, action.isBibRates);
    yield put(setRates(rates.data, action.page));
    yield put(setSelectedSP(rates.data.filter((r) => r.id !== 0)[0]));
  } catch (exception) {
    yield put(
      showNotificationErrorFromException(
        exception,
        'Could not load AFSCs. Please try again later.',
      ),
    );
  } finally {
    yield put(waiting(false));
  }
}

/**
 * LOAD ALL RATES (NO PAGINATION)
 */
function* loadAllRatesSaga() {
  yield takeLatest(LOAD_ALL_RATES, callLoadAllRates);
}

function* callLoadAllRates(action) {
  try {
    yield put(waiting(true));
    const rates = yield call(api.getRates);
    yield put(setAllStudyPrograms(rates.data));
  } catch (exception) {
    yield put(
      showNotificationErrorFromException(
        exception,
        'Could not load AFSCs. Please try again later.',
      ),
    );
  } finally {
    yield put(waiting(false));
  }
}

/**
 * LOAD QUALS
 */
function* loadQualsSaga() {
  yield takeLatest(LOAD_QUALS, callLoadQuals);
}

function* callLoadQuals(action) {
  try {
    yield put(waiting(true));
    const quals = yield call(api.getQuals, action.page);
    yield put(setQuals(quals, action.page));
  } catch (exception) {
    yield put(
      showNotificationErrorFromException(
        exception,
        'Could not load quals. Please try again later.',
      ),
    );
  } finally {
    yield put(waiting(false));
  }
}

/**
 * CREATE RATE
 */
function* createRateSaga() {
  yield takeLatest(CREATE_RATE, callCreateRate);
}

function* callCreateRate(action) {
  try {
    yield put(waiting(true));
    const sp = yield call(api.createRate, action.fields);

    if (!action.fields.isQual) {
      yield call(callLoadRates, { page: null });
    } else {
      yield call(callLoadQuals, { page: null });
    }
    yield put(setSelectedSP(sp));
    const type = action.fields.isQual ? 'Qual' : 'AFSC';
    yield put(
      Notifications.show(
        {
          title: 'Done!',
          message: `${type} created successfully`,
          autoDismiss: 1,
        },
        'success',
      ),
    );
  } catch (exception) {
    yield put(
      showNotificationErrorFromException(
        exception,
        'Could not create the AFSC. Please try again later.',
      ),
    );
  } finally {
    yield put(waiting(false));
    yield put(closeModal());
  }
}

/**
 * UPDATE STUDY PROGRAM
 */
function* updateSPSaga() {
  yield takeLatest(UPDATE_SP, updateSP);
}

function* updateSP(action) {
  try {
    yield put(waiting(true));
    const sp = yield call(api.updateSP, action.fields);
    const type = action.fields.isQual ? 'Qual' : 'Rate';
    sp.isQual = action.fields.isQual;
    sp.type = type.toLowerCase();
    yield put(updateSPAction(sp));
    yield put(
      Notifications.show(
        {
          title: 'Done!',
          message: action.fields.isQual
            ? 'Qual updated successfully'
            : 'AFSC updated successfully',
          // message: `${type} updated successfully`,
          autoDismiss: 1,
        },
        'success',
      ),
    );
  } catch (exception) {
    yield put(
      showNotificationErrorFromException(
        exception,
        'Could not create the AFSC. Please try again later.',
      ),
    );
  } finally {
    yield put(waiting(false));
  }
}

/**
 * UPDATE STUDY PROGRAM
 */
function* deleteSPSaga() {
  yield takeLatest(DELETE_SP, deleteSP);
}

function* deleteSP(action) {
  try {
    yield put(waiting(true));
    yield call(api.deleteSP, action.sp);
    yield put(removeSP(action.sp));
    yield put(setSelectedSP({ type: action.sp.type }));
    const type = action.sp.type === 'qual' ? 'Qual' : 'AFSC';
    yield put(
      Notifications.show(
        {
          title: 'Done!',
          message: `${type} deleted successfully`,
          autoDismiss: 1,
        },
        'success',
      ),
    );
  } catch (exception) {
    yield put(
      showNotificationErrorFromException(
        exception,
        'Could not delete the AFSC. Please try again later.',
      ),
    );
  } finally {
    yield put(waiting(false));
  }
}
/**
 * DEFAUL EXPORT
 */
export default function* sagas() {
  yield all([
    loadRatesSaga(),
    createRateSaga(),
    loadQualsSaga(),
    loadAllRatesSaga(),
    updateSPSaga(),
    deleteSPSaga(),
  ]);
}

function showNotificationErrorFromException(exception) {
  const message = getRequestErrorMessage(exception);

  return Notifications.show({ title: 'Ops!', message }, 'error');
}
